export default "__VITE_ASSET__chfKUsO8__"